<template>
    <div class="responsive-table">
        <table>
            <thead>
                <tr>
                    <th>{{ filial }}</th>
                </tr>
            </thead>
            <tbody>
                <Competencia
                    :competencia="competencia"
                    :recibos="Recibos"
                    :agrupamento="agrupamento"
                    :tipo_periodo="tipo_periodo"
                    :propriedades="propriedades"
                    :total_filial="index == Competencias.length - 1 ? total : 0"
                    v-for="(competencia, index) in Competencias"
                    :key="competencia"
                ></Competencia>
                <Imovel
                    :codigo_imovel="imovel"
                    :recibos="Recibos"
                    :agrupamento="agrupamento"
                    :tipo_periodo="tipo_periodo"
                    :propriedades="propriedades"
                    :total_filial="index == Imoveis.length - 1 ? total : 0"
                    v-for="(imovel, index) in Imoveis"
                    :key="imovel"
                ></Imovel>
            </tbody>
        </table>
    </div>
</template>
<script>
import Competencia from "./competencia.vue";
import Imovel from "./imovel.vue";
export default {
    props: ["filial", "recibos", "agrupamento", "tipo_periodo", 'propriedades'],
    components: {
        Competencia,
        Imovel,
    },
    computed: {
        Recibos() {
            let recibos = this.recibos.filter((recibo) => {
                return recibo.Filial == this.filial;
            });
            return recibos;
        },
        Competencias() {
            if (this.agrupamento == "Imóvel") {
                return [];
            }
            let competencias = [
                ...new Set(this.Recibos.map(({ Competencia }) => Competencia)),
            ];
            return competencias;
        },
        Imoveis() {
            if (this.agrupamento == "Competência") {
                return [];
            }
            let imoveis = [
                ...new Set(this.Recibos.map(({ Imovel }) => Imovel)),
            ];
            return imoveis;
        },
        total() {
            let total = this.Recibos.reduce(
                (acc, recibo) => acc + recibo.Valor,
                0
            );
            return total;
        },
    },
};
</script>